const routes = [
  {
    path: "/video_tutorials",
    component: () => import("views/VideoTutorial/List.vue"),
    name: "video_tutorials",
    meta: { role: ["anyone"] },
  },
];

export default routes;
